import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { HeaderComponent } from './layouts/admin-layout/header/header.component';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { sharedLibModule } from "../../../shared/src/lib/shared-lib.module";
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationComponent } from './layouts/admin-layout/header/notification/notification.component';

import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SharedModule } from './shared/shared.module';
import { ToastsComponent } from './layouts/admin-layout/toasts/toasts.component';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    HeaderComponent,
    BasicLayoutComponent,
    NotificationComponent,
    ToastsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    sharedLibModule,
    SharedModule,
    InfiniteScrollDirective,
    NgbModule,
    TranslateModule.forRoot({
      defaultLanguage: localStorage.getItem('language') || 'ar',
      loader: {
        provide: TranslateLoader,
        useFactory: (HttpLoaderFactory),
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService,
        private router: Router,
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['lang'] && (params['lang'] == 'ar' || params['lang'] == 'en')) {
        let paramLang = params['lang'];
        this.router.navigate([], {
          queryParams: { lang: '' },
          queryParamsHandling: 'merge',
        });
        if (localStorage.getItem('language') && (localStorage.getItem('language') !== paramLang)) {
          translate.use(paramLang);
          localStorage.setItem('language', paramLang);
          location.reload();
        }
      }
    });
  }
}
